import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// UpsellOffer archetype — picks the first applicable rule from
// `adapters.upsellRules`. Auto-skips when no rule matches.
// Behavior ported from apps/portal/src/signup/steps/UpsellStep.tsx.
import { useEffect, useMemo } from 'react';
import { s } from './common.js';
export function UpsellOfferComponent(props) {
    const { config, payload, adapters, advance, back, isAdvancing } = props;
    const planIdPath = s(config, 'planIdPath', 'planId');
    const acceptedPath = s(config, 'acceptedPath', 'upsellAccepted');
    const rules = adapters.upsellRules ?? [];
    const currentPlanId = (() => {
        const parts = planIdPath.split('.');
        let cur = payload;
        for (const p of parts) {
            if (cur && typeof cur === 'object' && p in cur) {
                cur = cur[p];
            }
            else
                return null;
        }
        return typeof cur === 'string' ? cur : null;
    })();
    const alreadyShown = payload[acceptedPath] &&
        typeof payload[acceptedPath] === 'object'
        ? payload[acceptedPath]
        : {};
    const rule = useMemo(() => {
        if (!currentPlanId)
            return null;
        return (rules.find((r) => r.triggerWhenPlanIn.includes(currentPlanId) && !(r.id in alreadyShown)) ?? null);
    }, [rules, currentPlanId, alreadyShown]);
    useEffect(() => {
        if (!rule && !isAdvancing) {
            void advance({});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rule]);
    if (!rule) {
        return _jsx("div", { className: "text-sm text-[var(--bcbb-text-muted)]", children: "Continuing\u2026" });
    }
    function accept() {
        void advance({
            [planIdPath]: rule.offerPlanId,
            [acceptedPath]: { ...alreadyShown, [rule.id]: true },
        });
    }
    function decline() {
        void advance({
            [acceptedPath]: { ...alreadyShown, [rule.id]: false },
        });
    }
    return (_jsxs("div", { className: "flex flex-col gap-5", children: [_jsx("div", { className: "whitespace-pre-line rounded-xl border border-[var(--bcbb-border)] bg-white p-5 text-sm", children: rule.copy }), _jsxs("div", { className: "flex flex-col gap-2", children: [_jsx("button", { type: "button", onClick: accept, disabled: isAdvancing, className: "rounded-md px-5 py-3 text-base font-semibold text-white", style: { background: 'var(--bcbb-primary)' }, children: isAdvancing ? 'Saving…' : `Yes, upgrade to ${rule.offerPlanId}` }), _jsx("button", { type: "button", onClick: decline, disabled: isAdvancing, className: "rounded-md border bg-white px-4 py-2 text-sm font-medium", style: { borderColor: 'var(--bcbb-border)' }, children: "No, keep my current plan" })] }), _jsx("div", { className: "mt-2", children: _jsx("button", { type: "button", onClick: back, disabled: isAdvancing, className: "rounded-md border bg-white px-4 py-2 text-sm font-medium", style: { borderColor: 'var(--bcbb-border)' }, children: "Back" }) })] }));
}
export const UpsellOfferArchetype = {
    name: 'UpsellOffer',
    label: 'Upsell offer',
    description: 'Picks the first applicable rule from the global upsell pool; auto-skips otherwise.',
    component: UpsellOfferComponent,
    isFormArchetype: false,
    fields: {
        planIdPath: { kind: 'text', label: 'Plan id payload key', defaultValue: 'planId' },
        acceptedPath: { kind: 'text', label: 'Accepted-map payload key', defaultValue: 'upsellAccepted' },
    },
    defaultConfig: { planIdPath: 'planId', acceptedPath: 'upsellAccepted' },
};
